var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pd_title"},[_c('span',[_vm._v(_vm._s(_vm.problem.courseName))])]),_vm._v(" "),_c('div',{staticClass:"pd_stitle"},[_c('span',[_vm._v(_vm._s(_vm.problem.classname))])]),_vm._v(" "),_c('div',{staticClass:"pd_text"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.problem.text)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c2e1d28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/components/problemDetail.vue
// module id = null
// module chunks = 